import { StorageService } from "./storage.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { Uris } from "./Uris";

@Injectable({
  providedIn: "root"
})
export class WaterwiseService {
  constructor(
    public storageService: StorageService,
    private http: HttpClient,
    public router: Router
  ) {}

  getWaterwises(query: string = "") {
    return this.http.get(`${Uris.WATERWISE}${query}`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  getWaterwise(id: number | string, query: string = "") {
    return this.http.get(`${Uris.WATERWISE}${id}/${query}`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  postWaterwise(value: any) {
    return this.http.post(`${Uris.WATERWISE}`, value, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", `Waterwise creado correctamente`);
        return resp;
      })
    );
  }

  /**
   * Actualiza un waterwise existente.
   * @param id Identificador del waterwise.
   * @param value Payload a enviar al backend.
   * @param showAnimation Define si se muestra la notificacion de exito.
   * @returns Observable con la respuesta del backend.
   */
  patchWaterwise(id: number | string, value: any, showAnimation: boolean = true) {
    return this.http.patch(`${Uris.WATERWISE}${id}/`, value, this.storageService.headers()).pipe(
      map((resp: any) => {
        if (showAnimation) {
          this.storageService.animation("success", "Éxito", `${resp.name} editado correctamente`);
        }
        return resp;
      })
    );
  }
  EditMasiveWaterwises(value: any, query: string) {
    return this.http
      .put(`${Uris.WATERWISE}multiple_update/${query}`, value, this.storageService.headers())
      .pipe(
        map((resp: any) => {
          this.storageService.animation("success", "Éxito", `Waterwises editados correctamente`);
          return resp;
        })
      );
  }

  deleteWaterwise(id: number | string) {
    return this.http.delete(`${Uris.WATERWISE}${id}/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation("success", "Éxito", `Dispositivo eliminado correctamente`);
        return resp;
      })
    );
  }

  sendCommandToWaterwise(id: number | string, value: any) {
    return this.http
      .post(`${Uris.WATERWISE}${id}/send_command/`, value, this.storageService.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }

  getWaterwiseLog(query: string = "") {
    return this.http.get(`${Uris.WATERWISE_LOG}${query}`, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }

  /* WIP: THIS FUNCTION IS FOR SENDING THE FRAME */
  setPointsSensorsAquaLogger(id: number | string, body: any) {
    return this.http
      .post(`${Uris.GATEWAYFRAMESWATERWISE}${id}/set_points/`, body, this.storageService.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }
  /* PROMEDIO DE SENSORES */
  getWaterwiseHydroSensorsHistoricalByType(query: string = "") {
    return this.http
      .get(
        `${Uris.WATERWISE}hydro_sensors_history/sensor-graph/${query}`,
        this.storageService.headers()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }

  getWaterwiseSensorsHistorical(id: number | string, query: string = "") {
    return this.http
      .get(`${Uris.WATERWISE}hydro_sensors_history/${id}/${query}`, this.storageService.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }

  getWaterwiseHydroSensorsHistoricalGraph(query: string = "") {
    return this.http
      .get(`${Uris.WATERWISE}hydro_sensors_history/graph/${query}`, this.storageService.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }
  getWaterwiseSensorsHistoricalGraph(query: string = "") {
    return this.http
      .get(`${Uris.WATERWISE}sensors_history/graph/${query}`, this.storageService.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }
  multipleUpdateWaterwise(query: string, body: any) {
    return this.http
      .put(`${Uris.WATERWISE}multiple_update/${query}`, body, this.storageService.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }
  getWaterwiseSensorNotifications(query: string = "") {
    return this.http
      .get(`${Uris.WATERWISE}sensors/alert/${query}`, this.storageService.headers())
      .pipe(
        map((resp: any) => {
          return resp;
        })
      );
  }

  getWaterwiseAlerts(query: string = "") {
    return this.http.get(Uris.ALERTS + query, this.storageService.headers()).pipe(
      map((resp: any) => {
        return resp;
      })
    );
  }
}
